(function () {
  if (window.__abmiumCountryFlagsReady) return;
  window.__abmiumCountryFlagsReady = true;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[aria-controls^="HeaderCountryList"]');
    if (!toggle) return;
    var dropdown = toggle.closest('.dropdown');
    if (!dropdown) return;
    Array.prototype.forEach.call(dropdown.querySelectorAll('img[data-abmium-country-flag]'), function (image) {
      image.src = image.getAttribute('data-abmium-country-flag');
      image.removeAttribute('data-abmium-country-flag');
    });
  });
})();